import React, { Component } from 'react';
import Swiper from 'react-id-swiper';
import styled from 'styled-components';
import Left from 'react-icons/lib/md/chevron-left';
import Right from 'react-icons/lib/md/chevron-right';
import { Flex, media } from 'lib/style-utils';
import ScrollDown from './ScrollDown';
import scrollToComponent from 'react-scroll-to-component';
import './swiper.css';

/** Total Wrapper */
const SwiperWrapper = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  background: ${props => props.color};
  transition: background 0.8s;

  ${media.iphone67p`
    height: 696px;

    .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets {
      bottom: 25px;
    }

    & .swiper-container {
      height: 696px;
    }
  `}
  ${media.iphone67`
      height: 627px;

      & .swiper-container {
        height: 627px;
      }
  `}

  .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets {
    top: auto;
    bottom: 25px;
  }
`;

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  &:hover {
    & img {
      -webkit-clip-path: circle(100% at 50% 50%);
      clip-path: circle(100% at 50% 50%);
    }
  }
`;

/** Previous, Next Button */
const BtnWrapper = styled.div`
  position: absolute;
  left: 67px;
  bottom: 30px;
  width: 120px;
  z-index: 15;
  cursor: pointer;

  ${media.tablet`
    top: 40%;
    left: 0;
    width: 100vw;
    height: 50px;

    & > .left {
      position: absolute;
      top: 0;
      left: 0;
      margin: 0;
    }

    & > .right {
      position: absolute;
      top: 0;
      right: 0;
      margin: 0;
    }
  `}
  ${media.mobile`
      display: none;
  `}
`;

const Btn = Flex.extend`
  width: 50px;
  height: 50px;
  float: left;
  margin-right: 10px;
  font-size: 40px;
  background: #ffffff;
  color: #757575;
  border-radius: 50%;
  box-shadow: 2px 2px 8px 0px rgba(0,0,0,0.3);
  transition: all 0.3s;

  &:hover {
    background: #eeeeee;
  }

  &:active {
    box-shadow: none;
    background: #d5d5d5;
    transform: translateY(2px);
  }

  ${media.mobile`
    display: none;
  `}
`;

/** Swiper Elements */
const Image = styled.img`
  width: 100%;
  height: 100vh;
  -webkit-clip-path: circle(50vh at 50% 50%);
  clip-path: circle(50vh at 50% 50%);
  object-fit: cover;
  transition: all 1s ease-in-out;

  ${media.tablet`
    -webkit-clip-path: circle(45vw at 50% 50vw);
    clip-path: circle(45vw at 50% 50vw);
  `}
  ${media.iphone67p`
    -webkit-clip-path: circle(50vw at 50% calc(50vw + 78px));
    clip-path: circle(50vw at 50% calc(50vw + 78px));
  `}
`;

/** Swiper Text */
const TextWrapper = styled.div`
  position: absolute;
  bottom: 120px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 15;
  text-shadow: 1px 1px 10px rgba(0,0,0,0.4);

  ${media.tablet`
    bottom: 14%;
    width: 100%;
  `}
  ${media.mobile`
    bottom: 15%;
    width: 100%;
  `}
  ${media.iphone67p`
    top: 510px;
  `}
  ${media.iphone67`
    top: 460px;
  `}
`;

const Season = styled.p`
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 5.8px;
  text-align: center;
  color: #fff;

  ${media.mobile`
    font-size: 26px;
    letter-spacing: 5.2px;
  `}
  ${media.se`
    font-size: 25px;
  `}
`;

const Year = styled.p`
  margin-top: 16px;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 3.2px;
  text-align: center;
  color: #fff;

  ${media.mobile`
    font-size: 16px;
  `}
`;

class MainCarousel extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps;
  }

  prev = () => {
    this.swiper.slidePrev();
  }

  next = () => {
    this.swiper.slideNext();
  }

  handleScrollDown = () => {
    const innerHeight = window.innerHeight;

    scrollToComponent(document.body, {
      offset: innerHeight,
      align: 'top',
      duration: 1000,
    });
  }

  render() {
    const { prev, next, handleScrollDown } = this;
    const { color, homeData } = this.props;

    /** Swiper init */
    const params = {
      pagination: '.swiper-pagination',
      paginationClickable: true,
      spaceBetween: 0,
      speed: window.innerWidth > window.innerHeight ? 1000 : 500,
      loop: true,
      autoplay: window.innerWidth >= 1024 ? 0 : 3000,
      autoplayDisableOnInteraction: true,
      onInit: (swiper) => {
        this.swiper = swiper;
      }
    };

    return (
      <SwiperWrapper color={color}>
        <TextWrapper>
          <Season color={color}>{homeData.mainCarouselText1}</Season>
          <Year color={color}>{homeData.mainCarouselText2}</Year>
        </TextWrapper>

        <Swiper {...params}>
          <Wrapper>
            <Image src={homeData.mainCarousel1 && homeData.mainCarousel1.url}/>
          </Wrapper>

          <Wrapper>
            <Image src={homeData.mainCarousel2 && homeData.mainCarousel2.url}/>
          </Wrapper>

          <Wrapper>
            <Image src={homeData.mainCarousel3 && homeData.mainCarousel3.url}/>
          </Wrapper>
        </Swiper>

        <BtnWrapper>
          <Btn className="left" onClick={prev}>
            <Left className="mobile-hidden"/>
          </Btn>
          <Btn className="right" onClick={next}>
            <Right className="mobile-hidden"/>
          </Btn>
        </BtnWrapper>

        <ScrollDown color={color} onClick={handleScrollDown}/>
      </SwiperWrapper>
    );
  }
}

export default MainCarousel;



// WEBPACK FOOTER //
// ./src/components/Home/MainCarousel.js